export default "__VITE_ASSET__487aa35a__"